import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getContactAdmin, deleteContactEntry, reorderContact } from '../../../../api/contact'
import { Button, Tooltip, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function localizedTitle(title) {
  if (!title || typeof title !== 'object') return ''
  if (title.es) return String(title.es)
  const first = Object.values(title).find((v) => v != null && String(v).trim())
  return first != null ? String(first) : ''
}

function sortEntries(entries) {
  return (entries || [])
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
}

function getData(entries) {
  return sortEntries(entries).map((e, index) => ({
    id: e._id,
    title: localizedTitle(e.title),
    phone: e.phone || '',
    email: e.email || '',
    active: e.active !== false ? 'Sí' : 'No',
    index,
  }))
}

export default function ContactPage() {
  const [data, setData] = useState([])
  const [entryId, setEntryId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function moveEntry(index, direction) {
    const sorted = sortEntries(data)
    const target = index + direction
    if (target < 0 || target >= sorted.length) return

    const next = [...sorted]
    const tmp = next[index]
    next[index] = next[target]
    next[target] = tmp
    const withOrder = next.map((e, i) => ({ ...e, order: i }))
    setData(withOrder)

    const orders = withOrder
      .filter((e) => e._id)
      .map((e) => ({ id: e._id, order: e.order }))
    if (!orders.length) return

    reorderContact(orders).catch((error) => {
      alertError({ error, customMessage: 'No se pudo guardar el orden.' })
      setRefresh(true)
    })
  }

  function orderFormatter(cell, row) {
    const index = row.index
    const isFirst = index === 0
    const isLast = index === data.length - 1
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Subir">
          <span>
            <IconButton
              size="small"
              disabled={isFirst}
              onClick={() => moveEntry(index, -1)}
              aria-label="Subir"
            >
              <ArrowUpwardIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Bajar">
          <span>
            <IconButton
              size="small"
              disabled={isLast}
              onClick={() => moveEntry(index, 1)}
              aria-label="Bajar"
            >
              <ArrowDownwardIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    )
  }

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push('/edit-contact/' + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setEntryId(cell)
              setOpenConfirmDialog(true)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'title', text: 'Título', sort: true },
    { dataField: 'phone', text: 'Teléfono', sort: true },
    { dataField: 'email', text: 'Correo', sort: true },
    { dataField: 'active', text: 'Activo', sort: true },
    { dataField: 'index', text: 'Orden', formatter: orderFormatter, sort: false },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getContactAdmin()
      .then((res) => {
        if (res.status === 200) {
          setData(sortEntries(res.data.entries || []))
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar los datos de contacto.' })
      })
  }, [refresh])

  return (
    <Card>
      <CardHeader title="Contacto (web)">
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => history.push('/edit-contact')}
          >
            Añadir entrada
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Table data={getData(data)} columns={columns} />
        <ConfirmDialog
          title="¿Eliminar esta entrada de contacto?"
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteContactEntry(entryId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Entrada eliminada.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar la entrada.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
